// Source
import * as HelperSrc from "../HelperSrc";

export default class StorePreference<T> {
    storageSet = (value: T): void => {
        HelperSrc.writeStorage<T>("preference", value);

        HelperSrc.storageDispatchEvent("preference");
    };

    storageGet = (): T | undefined => {
        return HelperSrc.readStorage<T>("preference");
    };

    storageRemove = (): void => {
        HelperSrc.removeStorage("preference");
    };
}
